interface EmptyStateProps {
  message?: string;
}

export function EmptyState({ message }: EmptyStateProps) {
  return (
    <div
      style={{
        height: 320,
        display: 'grid',
        placeItems: 'center',
        color: 'var(--muted)',
        fontSize: '0.95rem',
        textAlign: 'center',
        padding: '0 1rem',
      }}
    >
      <p>{message ?? 'Collecting data, check back tomorrow.'}</p>
    </div>
  );
}
